import { TradingPage } from '@/components/trading';

export default function FuturePage() {
  return <TradingPage />;
}
